export default [
  'Futuristic cityscape with neon lights',
  'Majestic wolves in a moonlit forest',
  'Surreal underwater world with bioluminescent creatures',
  'Steampunk-inspired flying machines',
  'Abstract city skyline in a watercolor painting',
  'A futuristic robot blending into a natural landscape',
  'Renaissance-style royal portrait with modern twist',
  'African savannah with wildlife in an impressionist style',
  'Extraterrestrial beings exploring an alien landscape',
  'Futuristic cityscape with soaring skyscrapers',
  "Snow-capped peaks in twilight's soft glow",
  "Kitten's playful antics with yarn",
  'Enchanted forest under moonlit sky',
  'Vintage film noir scene in a dim alley',
  'Robot chef prepares gourmet meal',
  'Time-traveler explores alien ruins',
  'Ethereal underwater world with coral reefs',
  'Steampunk airship embarks on skyward adventure',
  'Whimsical circus with acrobats and clowns',
  'Alien encounter beneath star-studded sky',
  'Fashion runway with avant-garde designs',
  'Secret agent on covert espionage mission',
  'Dreamy beach at sunset with golden sands',
  'Wildlife safari observes savannah creatures',
  'Futuristic cityscape at dusk',
  'Serene forest with a hidden creature',
  'Futuristic robot enjoying a sunset',
  'Majestic lioness in the ethereal moonlight',
  'Vibrant iridescent hummingbird in graceful flight',
  'Wise and contemplative old owl perched on a mossy branch',
  'Playful and fiery red fox frolicking in a sun-dappled forest',
  'Vivid and teeming coral reef teeming with marine life',
  'Gleaming futuristic cityscape with towering skyscrapers',
  'Advanced robots diligently constructing a bustling metropolis',
  'Harmonious utopian society thriving under shimmering domes',
  'Exhilarating time travel adventure through swirling portals',
  'Thrilling virtual reality gaming in a neon-lit cyberverse',
  'Smart city skyline illuminated with neon lights and holograms',
  "Surreal world within a computer's intricate circuits",
  'Futuristic fashion show with avant-garde designs and holograms',
  'Resilient individual gazing into the horizon, weathering a storm',
  'Secret agent on a daring mission in a covert operation',
  'Tranquil forest lake surrounded by towering ancient trees',
  'Thunderstorm brewing over a vast, ominous landscape',
  'Hidden waterfall cascading through a lush emerald canyon',
  'Serene mountain peak piercing through a sea of clouds',
  'Field of wildflowers stretching to the horizon, painted in vibrant hues',
  'Mesmerizing cosmic black hole with swirling galaxies',
  'Space station in orbit around a distant celestial body',
  "Nebula's breathtaking and kaleidoscopic hues",
  'Starship embarking on an epic interstellar exploration',
  'Futuristic jungle adventure in a biodome of bioluminescence',
  'People living harmoniously with nature in sustainable cities',
  'Galactic society on a lush, alien planet with floating islands',
  'Holographic architects at work designing sustainable cities',
  'Futuristic transportation solutions revolutionizing urban mobility',
  'Virtual reality education, transporting students to historic epochs',
  'Lush alien rainforest with phosphorescent flora and fauna',
  'Celestial garden in space, blossoming amid cosmic wonders',
  'Cosmic oasis on a desert planet, with shimmering oases',
  "Nature's beauty among distant stars, a breathtaking cosmic vista",
  'Extraterrestrial wildlife documentary capturing alien creatures',
  'Passionate scientist bonding with a gentle panda cub',
  'Symphony orchestra of melodious birds serenading the dawn',
  'People and dolphins working together in a marine research',
  'Futuristic zoo preserving endangered species',
  'Mythical sea creature underwater',
  'Bustling alien marketplace',
  'Surreal landscape with floating islands',
  'Futuristic astronaut on an alien planet',
  'Cyberpunk street with neon signs',
  'Futuristic sports car in a neon city',
  'Dragon soaring through a fantasy sky',
  'Futuristic space station orbiting Earth',
  'Futuristic train station at night',
  'Futuristic beach resort',
  'Majestic phoenix in flight',
  'Cyberpunk hacker in a neon-lit room',
  'Submarine exploring the deep',
  'Futuristic underwater city',
  'Surreal desert with floating rocks',
  'Futuristic zoo with holographic animals',
  'Robot painter at work'
];
